import React from "react";
import { useNavigate } from "react-router";
import { useModal } from "@ebay/nice-modal-react";

import IconCircleFrame from "Components/UI/IconCircleFrame/IconCircleFrame";
import {
  ExportBlackIcon,
  ExportDocumentIcon,
  ImportBlackIcon,
  ImportIcon,
  ThreeDotsHorizontalBlackIcon,
  ThreeDotsHorizontalIcon,
} from "Assets";
import { IMPORT_FILES } from "Shared/Constants/routes";
import { ExportFilesModal } from "Containers/ExportFiles/ExportFilesModal/ExportFilesModal";

import Meatballs, { MeatballsCallback } from "../../UI/Meatballs/Meatballs";
import { useTheme } from "Shared/Hook/useTheme";

type ImportExportButtonProps = {
  link: string;
  isExport?: boolean;
  isImport?: boolean;
  onImportClick?: () => void;
  currentParams?: Record<string, string | number | null | undefined>;
};

const ImportExportButton: React.FC<ImportExportButtonProps> = ({
  link,
  isImport = true,
  isExport = true,
  onImportClick,
  currentParams,
}) => {
  const navigate = useNavigate();
  const exportModal = useModal(ExportFilesModal);

  const isLightTheme = useTheme() === "light";

  if (!isImport && !isExport) return null;

  const goToImportPage = () => {
    if (onImportClick) { onImportClick(); return; }
    navigate(`${IMPORT_FILES}/?link=${link}`);
  };

  const onExportClick = () => {
    exportModal.show({ template: link, currentParams });
  };

  const tableMeatballsOptions = () => {
    const options = [];

    if (isExport) {
      options.push({
        label: "Export",
        key: "export",
        icon: isLightTheme ? <ExportBlackIcon /> : <ExportDocumentIcon />,
      });
    }

    if (isImport) {
      options.push({
        label: "Import",
        key: "import",
        icon: isLightTheme ? <ImportBlackIcon /> : <ImportIcon />,
      });
    }

    return options;
  };

  const onMeatballsChange: MeatballsCallback<any> = (value, optionKey) => {
    if (optionKey === "import") goToImportPage();
    if (optionKey === "export") onExportClick();
  };

  const icons = isLightTheme
    ? ThreeDotsHorizontalBlackIcon
    : ThreeDotsHorizontalIcon;
  return (
    <Meatballs<any>
      value={{}}
      onChange={onMeatballsChange}
      options={tableMeatballsOptions()}
    >
      <IconCircleFrame bgColor="transparent" icon={icons} />
    </Meatballs>
  );
};

export default ImportExportButton;
